import { render, staticRenderFns } from "./crearCuentaBancaria.vue?vue&type=template&id=e1532fae"
import script from "./crearCuentaBancaria.vue?vue&type=script&lang=js"
export * from "./crearCuentaBancaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports